import loginGrid from '@/assets/login-grid.svg';

export function LoginBackground() {
  return (
    <div aria-hidden className="pointer-events-none absolute inset-0 overflow-hidden">
      <img
        src={loginGrid}
        alt=""
        className="absolute top-1/2 left-1/2 max-w-none -translate-x-1/2 -translate-y-1/2"
      />
      <div className="absolute -top-128 -right-167 size-250.5 rounded-full bg-auth-glow blur-[200px]" />
      <div className="absolute -bottom-148 -left-161 size-250.5 rounded-full bg-auth-glow blur-[200px]" />
    </div>
  );
}
